import { Box, Tooltip } from '@mui/material';
import { Icon24PremiumFilled, Icon24ShieldFilled } from '@care/react-embrace-icons';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/seoSegmentationListingPage';

export interface CaregiverBadgesProps {
  isPremium: Caregiver['member']['isPremium'];
  hasCareCheck: Caregiver['hasCareCheck'];
}
const Badge = ({ title, icon }: { title: string; icon: React.ReactNode }) => (
  <Tooltip title={title} arrow>
    <Box display="inline-flex" alignItems="center" justifyContent="center">
      {icon}
    </Box>
  </Tooltip>
);

export const CaregiverBadges = ({ isPremium, hasCareCheck }: CaregiverBadgesProps) => {
  return (
    <>
      {isPremium && <Badge title="Premium Care.com member" icon={<Icon24PremiumFilled />} />}
      {hasCareCheck && (
        <Badge title="Care.com Background Check completed" icon={<Icon24ShieldFilled />} />
      )}
    </>
  );
};
